


















































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

// Components
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import Welcome from '@/components/Global/Welcome.vue';
import ApprovalModal from '@/components/Modal/Mmic/ReportsApprovalMmic.vue';
import TermsConditionsModal from '@/components/Modal/TermsConditionsICT.vue';

// Services
import Brand from '@/services/Brand';
import Staff, { Approval, ApprovalError } from '@/services/Staff';
import * as Sentry from '@sentry/browser';

@Component({
	name: 'StaffApprovalsList',
	components: {
		Alert,
		ApprovalModal,
		Loading,
		TermsConditionsModal,
		Welcome,
	},
})
export default class ApprovalList extends Vue {
	private readonly Brand = Brand;

	private approvals: Approval[] = [];
	private errorLoading: boolean = false;
	private errorAction: unknown = null;
	private loading: boolean = false;
	private paginate: string[] = ['approvals'];
	private successApproved: boolean = false;
	private successDeleted: boolean = false;
	private successDenied: boolean = false;

	private async created(): Promise<void> {
		this.loading = true;
		try {
			const allApprovals: Array<Approval | ApprovalError> = (await Staff.getApprovals()).data;
			console.log({ allApprovals });

			const nonErrorApprovals = allApprovals.filter(
				(approval: Approval | ApprovalError): boolean => !('body' in approval),
			) as Approval[];

			this.approvals = nonErrorApprovals
				.filter((approval: Approval): boolean => approval.brand === Brand.getBrand())
				.sort(
					(a: Approval, b: Approval): number =>
						moment(b.date_requested).unix() - moment(a.date_requested).unix(),
				);
			console.log({ approvals: this.approvals });
		} catch (e) {
			Sentry.captureException(e);
			this.errorLoading = true;
		} finally {
			this.loading = false;
		}
	}

	private async approveRiskResourcesRequest(approval: Approval): Promise<void> {
		try {
			if (approval.category !== 'Risk Resources') {
				throw new TypeError("`approval.category` is not 'Risk Resources'");
			}

			await Staff.sendApproval(true, approval.sub, 'RISK_MANAGEMENT');
			this.successApproved = true;
			this.filterOutApproval(approval);
		} catch (e) {
			Sentry.captureException(e);
			this.errorAction = e.data.error;
		}
	}

	private async denyRiskResourcesRequest(approval: Approval): Promise<void> {
		try {
			if (approval.category !== 'Risk Resources') {
				throw new TypeError("`approval.category` is not 'Risk Resources'");
			}

			await Staff.sendApproval(false, approval.sub, 'RISK_MANAGEMENT');
			this.successDenied = true;
			this.filterOutApproval(approval);
		} catch (e) {
			Sentry.captureException(e);
			this.errorAction = e.data.error;
		}
	}

	private async deleteReportsRequest(approval: Approval): Promise<void> {
		try {
			if (approval.category !== 'Reports') {
				throw new TypeError("`approval.category` is not 'Reports'");
			}

			await Staff.sendApproval(false, approval.sub, 'REPORTS', true);
			this.successDeleted = true;
			this.filterOutApproval(approval);
		} catch (e) {
			Sentry.captureException(e);
			this.errorAction = e.data.error;
		}
	}

	private filterOutApproval(approval: Approval): void {
		this.approvals = this.approvals.filter((item: Approval): boolean => item !== approval);
	}
}
